import { filter, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { selectActiveView, selectViewHistory, selectSelectedLotId } from './selectors';
import { VIEW_MOBILE_LOT_CARD } from '../constants';

/**
 * Reacts to mapBackgroundClicked: dispatches navigateBack() when there's a sub-view to unwind,
 * or lotSelected(null) when already on the root listing AND a lot is actually selected — a
 * background click resolves to a real state change instead of silently no-op'ing when
 * viewHistory is empty (see PR #6618), but never dispatches lotSelected(null) when there's
 * nothing to clear (no history, no selection): that would just be noise, not a real transition.
 *
 * The mobile lot card is exempt: it keeps the map visible for browsing and owns its own Back
 * control, so a background tap there must leave the view alone — same reasoning as
 * selectLotRoutingOutcome's own VIEW_MOBILE_LOT_CARD branch.
 *
 * @param {object} params
 * @param {object} params.dataActions - Actions from the feature data slice instance
 * @returns {import('redux-observable').Epic}
 */
function createMapBackgroundClickedEpic({ dataActions }) {
  return (action$, state$) => action$.pipe(
    ofType(dataActions.mapBackgroundClicked.type),
    map(() => {
      const state = state$.value;
      if (selectActiveView(state) === VIEW_MOBILE_LOT_CARD) {
        return null;
      }
      if (selectViewHistory(state).length > 0) {
        return dataActions.navigateBack();
      }
      if (selectSelectedLotId(state) != null) {
        return dataActions.lotSelected(null);
      }
      return null;
    }),
    filter(Boolean),
  );
}

export default createMapBackgroundClickedEpic;
